import { render, staticRenderFns } from "./BibliothequeModule.vue?vue&type=template&id=e12d47bc"
import script from "./BibliothequeModule.vue?vue&type=script&lang=js"
export * from "./BibliothequeModule.vue?vue&type=script&lang=js"
import style0 from "./BibliothequeModule.vue?vue&type=style&index=0&id=e12d47bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports